export const customers = [
    {
        customer: 'Flare Electricals',
        projects: 13100,
        quotes: 1310,
        submittals: 5000,
        oMs: 131,
        winRate: 43,
        totalExtSellPrice: 10000000,
        services: 20000,
        freight: 1000,
        totalExtDiscountedCost: 100
    },
    {
        customer: 'Nova lighting',
        projects: 125,
        quotes: 125,
        submittals: 125,
        oMs: 131,
        winRate: 43,
        totalExtSellPrice: 500000000,
        services: 56666,
        freight: 455,
        totalExtDiscountedCost: 12333
    },
    {
        customer: 'AB Cosmetics',
        projects: 2344,
        quotes: 435,
        submittals: 125,
        oMs: 131,
        winRate: 56,
        totalExtSellPrice: 35006666,
        services: 45,
        freight: 555,
        totalExtDiscountedCost: 55
    },
    {
        customer: 'Yono Shuttles',
        projects: 54677,
        quotes: 125,
        submittals: 125,
        oMs: 5654,
        winRate: 93,
        totalExtSellPrice: 2234234,
        services: 1000,
        freight: 100,
        totalExtDiscountedCost: 77778
    },
    {
        customer: 'Yahoo Mail',
        projects: 34555,
        quotes: 777,
        submittals: 66,
        oMs: 555,
        winRate: 76,
        totalExtSellPrice: 10000000,
        services: 10000000,
        freight: 1000000,
        totalExtDiscountedCost: 10000
    },
    {
        customer: 'AB Cosmetics 1',
        projects: 2344,
        quotes: 435,
        submittals: 125,
        oMs: 131,
        winRate: 56,
        totalExtSellPrice: 35006666,
        services: 45,
        freight: 555,
        totalExtDiscountedCost: 55
    },
    {
        customer: 'Yono Shuttles 1',
        projects: 54677,
        quotes: 125,
        submittals: 125,
        oMs: 5654,
        winRate: 93,
        totalExtSellPrice: 2234234,
        services: 1000,
        freight: 100,
        totalExtDiscountedCost: 77778
    },
    {
        customer: 'Yahoo Mail 1',
        projects: 34555,
        quotes: 777,
        submittals: 66,
        oMs: 555,
        winRate: 76,
        totalExtSellPrice: 10000000,
        services: 10000000,
        freight: 1000000,
        totalExtDiscountedCost: 10000
    },
    {
        customer: 'AB Cosmetics 2',
        projects: 2344,
        quotes: 435,
        submittals: 125,
        oMs: 131,
        winRate: 56,
        totalExtSellPrice: 35006666,
        services: 45,
        freight: 555,
        totalExtDiscountedCost: 55
    },
    {
        customer: 'Yono Shuttles 2',
        projects: 54677,
        quotes: 125,
        submittals: 125,
        oMs: 5654,
        winRate: 93,
        totalExtSellPrice: 2234234,
        services: 1000,
        freight: 100,
        totalExtDiscountedCost: 77778
    },
    {
        customer: 'Yahoo Mail 2',
        projects: 34555,
        quotes: 777,
        submittals: 66,
        oMs: 555,
        winRate: 76,
        totalExtSellPrice: 10000000,
        services: 10000000,
        freight: 1000000,
        totalExtDiscountedCost: 10000
    }
];
